export const querySettings = { retry: 0, refetchOnWindowFocus: false, refetchOnReconnect: false };
